import React, { useState, useRef } from "react";
import Classes from "../Dashboard.module.css";

export default function MyDateRange() {
  const [startDate, setStartDate] = useState("2025-03-03");
  const [endDate, setEndDate] = useState("2025-03-09");
  const startInputRef = useRef(null);
  const endInputRef = useRef(null);

  // Function to trigger the date picker when clicking the icon
  const openStartDatePicker = () => startInputRef.current?.showPicker();
  const openEndDatePicker = () => endInputRef.current?.showPicker();

  return (
    <div className={Classes.flexAlign10} style={{ position: "relative" }}>
      {/* Display Selected Dates */}
      <div className={Classes.datePicker} style={{ padding: "0 10px" }}>
        <h5>
          {startDate} to {endDate}
        </h5>
      </div>

      {/* Date Selection */}
      <div className={Classes.flexAlign10}>
        <h5>From</h5>
        <div className={Classes.datePicker} style={{ cursor: "pointer", position: "relative" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="13px"
            width="16px"
            viewBox="0 0 448 512"
            onClick={openStartDatePicker}
          >
            <path d="M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z" />
          </svg>
          <input
            type="date"
            ref={startInputRef}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
            className={Classes.hiddenDateInput} // Hides input but keeps it functional
          />
        </div>

        <h5>to</h5>
        <div className={Classes.datePicker} style={{ cursor: "pointer", position: "relative" }}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="13px"
            width="16px"
            viewBox="0 0 448 512"
            onClick={openEndDatePicker}
          >
            <path d="M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z" />
          </svg>
          <input
            type="date"
            ref={endInputRef}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
            className={Classes.hiddenDateInput} // Hides input but keeps it functional
          />
        </div>
      </div>
    </div>
  );
}
